import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import { Button } from '@/components/button'
import { colors } from '@/styles'
import { Label } from '@/components/text'
import socialLoginImage from './images/enable-social-login.png'
import Context from '../context'

const DescriptionText = styled(Label)`
  color: ${colors.grey24};
  font-weight: 400;
  margin: 20px 0 32px;
`

const NoticeWrapper = styled.div`
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  justify-content: center;

  img {
    width: 400px;
    max-width: 100%;
  }
`

const Content = styled.div`
  width: 100%;
  margin-bottom: 12px;
`

const ButtonWrapper = styled.div`
  margin: 24px 0 0;
`

const ExistingSocialUser = () => {
  const history = useHistory()
  const { t } = useTranslation()
  const { setExistingSocialState } = useContext(Context)

  const handleSignInByEmail = () => {
    setExistingSocialState(false)
    history.push('/')
  }

  return (
    <>
      <DescriptionText fontSize="14px">
        {t(
          'b.auth.view.existing.user.description',
          'You haven’t enabled login by social accounts. Please sign in by email and navigate to your account settings to connect your social accounts.'
        )}
      </DescriptionText>
      <Content>
        <NoticeWrapper>
          <img src={socialLoginImage} alt="social login settings" />
        </NoticeWrapper>
        <ButtonWrapper>
          <Button
            id="web-existing-social-user-submit-button"
            theme="primary"
            width="100%"
            radius={6}
            shadow
            onClick={handleSignInByEmail}
          >
            {t('b.auth.view.existing.user.button', 'Sign In by Email')}
          </Button>
        </ButtonWrapper>
      </Content>
    </>
  )
}

export default ExistingSocialUser
